import { render } from "./PersonalInfoCard.vue?vue&type=template&id=44a062e9&scoped=true"
import script from "./PersonalInfoCard.vue?vue&type=script&lang=js"
export * from "./PersonalInfoCard.vue?vue&type=script&lang=js"

import "./PersonalInfoCard.vue?vue&type=style&index=0&id=44a062e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a062e9"]])

export default __exports__